import { HTTP_TOKEN_REPORT } from "./http";

export const getSale = (saleId) => {
  return HTTP_TOKEN_REPORT.get(`jorney-detail-sale/${saleId}`).then((result) => {
    return result.data;
  });
};

export const getLead = (leadId) => {
  return HTTP_TOKEN_REPORT.get(`jorney-detail-lead/${leadId}`).then((result) => {
    return result.data;
  });
};



export const getConversation = (whatsId) => {
  return HTTP_TOKEN_REPORT.get(`jorney-detail-whats/${whatsId}`).then((result) => {
    return result.data;
  });
};

export const createConversionMsg = (convId, params) => {
  return HTTP_TOKEN_REPORT.post(`jorney-detail-whats/${convId}`, params).then((result) => {
    return result.data;
  });
};




